import { useState, useEffect } from 'react';
import { api } from '../api/client';

const PROVIDER_LABEL = {
  google:  'Google Calendar',
  outlook: 'Outlook Calendar',
  apple:   'Apple Calendar',
};

const PROVIDER_GLYPH = {
  google:  '🗓',
  outlook: '📅',
  apple:   '🍎',
};

export { PROVIDER_LABEL, PROVIDER_GLYPH };

export default function useExternalCalendarEvents(start, end) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!start || !end) { setEvents([]); return; }
    setLoading(true);
    api(`/api/calendar/external?start=${encodeURIComponent(start)}&end=${encodeURIComponent(end)}`)
      .then(r => r.json())
      .then(d => setEvents(Array.isArray(d.events) ? d.events : []))
      .catch(() => setEvents([]))
      .finally(() => setLoading(false));
  }, [start, end]);

  return { events, loading };
}

// Filter events to those whose startTime falls on a given YYYY-MM-DD date (local time)
export function filterEventsForDate(events, dateStr) {
  return events.filter(ev => {
    if (!ev.startTime) return false;
    const d = new Date(ev.startTime);
    const local = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    return local === dateStr;
  });
}

export function fmtSyncedTime(iso) {
  try { return new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: true }); }
  catch { return null; }
}
